import { LoaderFunctionArgs } from "react-router-dom";
import {apiEndpoints} from "@/services/api/api.ts";
import {OrderSummaryDto} from "@/routes/orders/summary/types/orderSummaryDto.ts";

export async function orderSummaryLoader({
                                       params,
                                   }: LoaderFunctionArgs): Promise<OrderSummaryDto> {
    try {
        if (!params.orderId) {
            return {} as OrderSummaryDto;
        }
        const response = await apiEndpoints.getOrderSummary(params.orderId);
        if (response.success)
            return response.data as OrderSummaryDto;

        return {} as OrderSummaryDto;
    } catch (error) {
        throw new Error(error instanceof Error ? error.message : "Unknown error");
    }
}
